import PerfectScrollbar from 'perfect-scrollbar';

jQuery.noConflict();
jQuery( document ).ready(function( $ ) {

  //Add #soff_browse_catalogue_back_to_top height to body already existing padding-bottom
  if($('#soff_browse_catalogue_back_to_top').length>0){
    $('body').css('padding-bottom',parseInt($('body').css('padding-bottom'))+$('#soff_browse_catalogue_back_to_top').height() + parseInt($('#soff_browse_catalogue_back_to_top').css('padding-bottom')) + parseInt($('#soff_browse_catalogue_back_to_top').css('padding-top')));
  }

  //Back on top
  if($("#soff_page").offset().top-50 < $(window).scrollTop()){
    $('#soff_browse_catalogue_back_to_top').addClass('shown');
  }
  $(window).scroll(function(){
    if($("#soff_page").offset().top-50 < $(window).scrollTop()){
      $('#soff_browse_catalogue_back_to_top').addClass('shown');
    }
    else{
      $('#soff_browse_catalogue_back_to_top').removeClass('shown');
    }
  });
  $('#soff_browse_catalogue_back_to_top').on('click',function(e){
    $('html, body').animate({ scrollTop: ($("#soff_page").offset().top-50) }, 500);
  });

  //Countdown
  if($('.soff_interval').length>0){
    const uniqueId = 'soff_reloaded_' + window.location.pathname;
    var soff_intervals=$('.soff_interval');
    soff_intervals.each(function(){
      var format=$(this).data('format');
      var t = $(this).data('ends').split(/[- :]/);
      var d_ends = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]));
      $(this).countdown(d_ends);
      $(this).on('update.countdown',function(e){
        $(this).html(e.strftime(format));
        localStorage.removeItem(uniqueId);
      });
      $(this).on('finish.countdown',function(e){ 
        if (!localStorage.getItem(uniqueId)) {
          localStorage.setItem(uniqueId, 'true');
          location.reload();
        }     
      });
    });
  }

  //Clear search
  $('#soff_browse_filter_clear_search').on('click',function(e){
    e.preventDefault();
    $('#soff_keywords').val('');
    $('#soff_browse_filters_form').submit();
  });

  //Modals
  $('.soff_modal_container').each(function(){
    $(this).appendTo('body');
  });
  let isOverModal = false;
  if(window.matchMedia('(min-width: 992px)').matches){
    $('*[data-toggle="soff_modal"]').click(function(event){
      event.preventDefault();
      $('#' + $(this).data('target')).addClass('shown').hide().fadeIn('fast');
    });
    $('.soff_modal_close').click(function(event){
      event.preventDefault();
      $(this).closest('.soff_modal_container').fadeOut('fast', function(){
        $(this).closest('.soff_modal_container').removeClass('shown');
      })
    });
    $('.soff_modal_container').click(function(event){
      if(!isOverModal){
        $(this).fadeOut('fast', function(){
          $(this).removeClass('shown');
        })
      }
    });
  }
  else{
    $('*[data-toggle="soff_modal"]').click(function(event){
      event.preventDefault();
      $('#' + $(this).data('target')).addClass('shown');
    });
    $('.soff_modal_close').click(function(event){
      event.preventDefault();
      $(this).closest('.soff_modal_container').removeClass('shown');
    });
  }
  $('.soff_modal').hover(function(){
    isOverModal = true;
  }, function(){
    isOverModal = false;
  })

  //Select placeholder behaviour
  $('select').each(function() {
    if($(this).children(':selected').val()==""){
      $(this).addClass('not_selected');
    }
  }).on('change', function() {
    if($(this).children(':selected').val()==""){
      $(this).addClass('not_selected');
    }else{
      $(this).removeClass('not_selected');
    }
  });

  //Initialise perfect scrollbar
  if($('.soff_modal_content').length){
    const ps = new PerfectScrollbar('.soff_modal_content');
  }
  if($('.soff_table_container').length){
    const ps = new PerfectScrollbar('.soff_table_container');
  }

  //Call logout URLs if any provided
  $('.soff_logout_urls').each(function(index){
    $.ajax({
      url : $(this).data('url'),
      xhrFields: {
         withCredentials: true
      }
    });
  });

});
